import { CheckCircleOutlined } from '@ant-design/icons';
import { InlineMetadata } from './InlineMetadata';
import React from 'react';

export interface InlineCheckmarkMetadataProps {
	label: string;
	value: boolean | null | undefined;
}

export const InlineCheckmarkMetadata: React.FC<InlineCheckmarkMetadataProps> = ({ label, value }) =>
	<InlineMetadata label={ label }>{ value ? <CheckCircleOutlined /> : null }</InlineMetadata>;

